import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getActiveModal } from '../../selectors/common';
import PlayersTemplateModals from './PlayersTemplateModals';
import PlayerTemplateRows from './PlayersTemplateRows';
import { aSetOpenModal } from '../../reducers/common';

const mapToProps = (state) => ({
  activeModal: getActiveModal(state),
});

const actionsToProps = (dispatch) => ({
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
});
class PlayerTemplate extends Component {

  render() {
    return (
      <>
        <div className={`modal ${this.props.activeModal ? 'modal--open' : ''}`}>
          <PlayersTemplateModals
            setOpenModal={this.props.setOpenModal}
            activeModal={this.props.activeModal}
            leagues={this.props.leagues}
            closeModal={() => this.props.setOpenModal({ modal: '' })}
          />
        </div>
        {this.props.hasPermissionToView && (
          <div className="table-responsive m-t-30 fix-12">
            <table className="odds__table">
              <thead className="thead--green is-fix">
                <tr className="tr--primary">
                  <th>ID</th>
                  <th>File Name</th>
                  <th>Competition</th>
                  <th>Active</th>
                  <th>
                    Start Date
                    <i className="table-arrow ml-1" />
                  </th>
                  <th>End Date</th>
                </tr>
              </thead>
              <tbody>
                <PlayerTemplateRows
                  playerTemplateList={this.props.playersTemplate}
                  leagues={this.props.leagues}
                />
              </tbody>
            </table>
          </div>
        )}
        {this.props.hasPermissionToAdd && (
          <button
            className="btn btn-secondary m-t-30"
            type="button"
            onClick={() => this.props.setOpenModal({ modal: this.props.addModalName })}
            id="btn1"
          >
            {this.props.addBtnLabel}
          </button>
        )}
      </>
    );
  }
}

export default connect(mapToProps, actionsToProps)(PlayerTemplate);
